import React from "react";

export default function Credits() {
  return (
    <div className="credits">
      <a
        href="https://github.com/fedbz/my-app"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open-source code{" "}
      </a>
      by fedbz
    </div>
  );
}
